const getProductId = (location) =>
  location.state?.productId ||
  location.pathname.split("products/")[1].split("/")[0];

export default getProductId;
